import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  // base: "/zh_CN",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else if (to.path.includes("/Case") && !to.meta.scroll) {
      return false;
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  },
  routes: [
    {
      path: "/",
      component: () => import("../views/About.vue"),

      meta: {
        title: "关于拓弗勒",
        enTitle: 'ABOUT TOPS'
      }
    },
    {
      path: "/Index",
      component: () => import("../views/About.vue"),
      meta: {
        title: "关于拓弗勒",
        enTitle: 'ABOUT TOPS'
      }
    },
    {
      path: "/Leads",
      component: () => import("../views/Leads.vue"),

      meta: {
        title: "拓弗勒-在线登记",
        enTitle: 'TOPS-Online registration'
      }
    },

    {
      path: "/Product",
      component: () => import("../views/Product.vue"),

      meta: {
        title: "产品中心",
        enTitle: 'Product Center'
      },
      children: [
        {
          path: "ColorChange",
          component: () => import("../views/product/ColorChange"),
          meta: {
            title: "改色膜",
            keepAlive: true,
            enTitle: 'Wrapping Film'
          }
        },
        {
          path: "Colorful/:id?",
          component: () => import("../views/product/Colorful.vue"),
          meta: {
            title: "炫彩膜",
            enTitle: 'Colorful Film'
          }
        },
        {
          path: "G",
          component: () => import("../views/product/G.vue"),
          meta: {
            title: "G速膜",
            enTitle: 'G Film (Window Film)'
          }
        },
        {
          path: "HeadlightFilm",
          component: () => import("../views/product/HeadlightFilm.vue"),
          meta: {
            title: "大灯膜",
            enTitle: 'TPU Headlight Film'
          }
        },
        {
          path: "Paint",
          component: () => import("../views/product/Paint.vue"),
          meta: {
            title: "漆面保护膜",
            enTitle: 'Paint Protection Film'
          }
        },
        {
          path: "SkyLight",
          component: () => import("../views/product/SkyLight.vue"),
          meta: {
            title: "天窗膜",
            enTitle: 'Sunroof Protection Film'
          }
        }
      ]
    },
    {
      path: "/PaintDetail/:id",
      name: "PaintDetail",
      component: () => import("../views/Product/detail/PaintDetail.vue"),
      meta: {
        title: "漆面膜详情页面",
        enTitle: 'Paint Protection Film Info'
      }
    },
    {
      path: "/GDetail/:id",
      name: "GDetail",
      component: () => import("../views/Product/detail/GDetail"),
      meta: {
        title: "G速膜详情页面",
        enTitle: 'G Film Info'
      }
    },
    {
      path: "/ColorChangeSeries/:id",
      name: "ColorChangeSeries",
      component: () => import("../views/Product/detail/ColorChangeSeries.vue"),
      meta: {
        title: "改色膜详情页面",
        enTitle: 'Wrapping Film Info'
        // keepAlive: true
      }
    },
    {
      path: "/ColorChangeSeriesDetail/:id",
      name: "ColorChangeSeriesDetail",
      component: () =>
        import("../views/Product/detail/ColorChangeSeriesDetail.vue"),
      meta: {
        title: "改色膜详情页面",
        enTitle: 'Wrapping Film Info'
      }
    },
    {
      path: "/ColorfulDetail/:id",
      name: "ColorfulDetail",
      component: () => import("../views/Product/detail/ColorfulDetail.vue"),
      meta: {
        title: "炫彩膜详情页面",
        enTitle: 'Colorful Film Info'
      }
    },
    {
      path: "/SkyLightDetail/:id",
      name: "SkyLightDetail",
      component: () => import("../views/Product/detail/SkyLightDetail.vue"),
      meta: {
        title: "天窗膜详情页面",
        enTitle: 'Sunroof Protection Film Info'
      }
    },
    {
      path: "/Solution",
      name: "Solution",
      component: () => import("../views/Solution/index.vue"),
      meta: {
        title: "解决方案",
        enTitle: 'Solution'
      },
      children: [
        {
          path: "Train",
          component: () => import("../views/Solution/Train.vue"),
          meta: {
            title: "安装培训",
            enTitle: 'Installation Training'
          }
        },
        {
          path: "Train2",
          component: () => import("../views/Solution/Train2.vue"),
          meta: {
            title: "窗膜安装培训",
            enTitle: 'Film Installation Training'
          }
        },
        {
          path: "Installer",
          component: () => import("../views/Solution/Installer.vue"),
          meta: {
            title: "加入经销商",
            enTitle: 'Join Dealer'
          }
        },
        {
          path: "DAS",
          component: () => import("../views/Solution/DAS.vue"),
          meta: {
            title: "DAS 3D裁膜数据辅助系统",
            enTitle: 'DAS'
          }
        }
      ]
    },
    {
      path: "/Case/:code",
      name: "Case",
      component: () => import("../views/Case.vue"),
      meta: {
        title: "精彩案例",
        enTitle: 'Installation Cases'
      }
    },
    {
      path: "/CaseDetail/:id",
      name: "CaseDetail",
      component: () => import("../views/CaseDetail.vue"),
      meta: {
        title: "案例详情",
        enTitle: 'Case Info'
      }
    },
    {
      path: "/Dynamic",
      component: () => import("../views/Dynamic.vue"),
      meta: {
        title: "品牌动态",
        keepAlive: true,
        enTitle: 'News Center'
      }
    },
    {
      path: "/DynamicDetail/:id",
      component: () => import("../views/DynamicDetail.vue"),
      meta: {
        title: "品牌动态详情页",
        enTitle: 'News Center Info'
      }
    },
    {
      path: "/Help",
      component: () => import("../views/help.vue"),
      meta: {
        title: "帮助",
        enTitle: 'Help'
      },
      children: [
        {
          path: "Support",
          component: () => import("../views/help/Support.vue"),
          meta: {
            title: "技术支持",
            enTitle: 'Technical Support'
          }
        },
        {
          path: "Problem",
          component: () => import("../views/help/Problem.vue"),
          meta: {
            title: "常见问题",
            enTitle: 'Frequently Asked Questions'
          }
        },
        {
          path: "Authentication",
          component: () => import("../views/help/Authentication.vue"),
          meta: {
            title: "认证",
            enTitle: 'Authentication'
          }
        },
        {
          path: "Maintain",
          component: () => import("../views/help/Maintain.vue"),
          meta: {
            title: "保养",
            enTitle: 'Maintenance'
          }
        },
        {
          path: "SafelyFactor",
          component: () => import("../views/help/SafelyFactor.vue"),
          meta: {
            title: "产品安全参数",
            enTitle: 'Product safety parameters'
          }
        },
        {
          path: "Warranty",
          component: () => import("../views/help/Warranty.vue"),
          meta: {
            title: "质保信息",
            enTitle: 'WARRANTY Info'
          }
        },
        {
          path: "Guidance",
          component: () => import("../views/help/Guidance.vue"),
          meta: {
            title: "安装指导",
            enTitle: 'Installation Guide'
          }
        }
      ]
    },
    // 查询
    {
      path: "/Query",
      component: () => import("../views/Query.vue"),
      children: [
        {
          path: "Warranty",
          component: () => import("../views/query/Warranty.vue"),
          meta: {
            title: "质保查询",
            enTitle: 'Warranty Inquiry'
          }
        },
        {
          path: "Distributor",
          component: () => import("../views/query/Distributor.vue"),
          meta: {
            title: "经销商查询",
            enTitle: 'Find Dealer'
          }
        },
        {
          path: "Offer",
          component: () => import("../views/query/Offer.vue"),
          meta: {
            title: "报价查询",
            enTitle: 'Price Inquiry'
          }
        }
      ]
    },
    //===============
    {
      path: "/Home",
      component: () => import("../views/Home.vue"),
      meta: {
        title: "Home",
        keepAlive: true,
        enTitle: 'Home'
      }
    },
    {
      path: "/MobileWarranty",
      component: () => import("../views/query/MobileWarranty.vue"),
      meta: {
        title: "质保查询",
        enTitle: 'Warranty Inquiry'
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js